<script lang="ts">
import SectionSalarieCivilite from '@/generated/sections/SectionSalarieCivilite.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionSalarieCivilite
})

</script>
